<template>
  <div>
    <yunshubb />
  </div>
</template>

<script>
// 获取接口地址
import yunshubb from '@/components/yunshubb/yunshubb'

export default {
  name: 'Ysbb',
  components: {
    // sideMenu,
    // Header,
    yunshubb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
